import type {} from '@angular/localize/init';
import type { TranslationConfig } from '@bcf-v2/routes-statics/common/app/i18n-cache';
import { appRoutesI18nCache } from '../i18n-cache';

export function playerBetsRouteI18n(config?: TranslationConfig): string {
  if (config?.translateForLang && globalThis.$localizeForLang) {
    return globalThis.$localizeForLang`:url-segment@@player-bets-url-segment:player-bets`;
  }
  return (appRoutesI18nCache['player-bets'] ??= $localize`:url-segment@@player-bets-url-segment:player-bets`);
}
